/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigstoryhint3Inputs */

const en_crosspostingigstoryhint3 = /** @type {(inputs: Crosspostingigstoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single image; disappears after 24 hours.`)
};

const de_crosspostingigstoryhint3 = /** @type {(inputs: Crosspostingigstoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein einzelnes Bild; verschwindet nach 24 Stunden.`)
};

/**
* | output |
* | --- |
* | "A single image; disappears after 24 hours." |
*
* @param {Crosspostingigstoryhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigstoryhint3 = /** @type {((inputs?: Crosspostingigstoryhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigstoryhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigstoryhint3(inputs)
	return de_crosspostingigstoryhint3(inputs)
});
export { crosspostingigstoryhint3 as "crosspostingIgStoryHint" }